// extracted by mini-css-extract-plugin
export var flexcontainer = "compare-kits-section-module--flexcontainer--wk1ct";